import { NgModule } from '@angular/core';
import { TooltipModule } from '../tooltip/tooltip.module';
import { DotIndicatorComponent } from './dotindicator.component';

@NgModule({
  imports: [TooltipModule],
  declarations: [DotIndicatorComponent],
  exports: [DotIndicatorComponent],
})
export class DotIndicatorModule {}
